module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAOZJREFUWEftlVENwlAMRc8UgAQcgARQADgAB0gYCpAAOAAFIAEcIAEJ5CZ9CeGvfS9ZSNrvZT09ves6Bq5u4P4kQBpIA39nYAVMgX2r++E18DCAC7AF3rUgXoAZcAdGgGAWtRBeAA0siJOZeAFrgwnJiACo0dhMKA9ag0zIiLuiAAVCJpYGoUwoG66qASjruJmRM7BxdYeqv6GyUJo/gXkkkFEDmvRgk19t8tAnGQFQ86OpDmn/XpMXYGeT6x26hr1357/PewHKJVTi9QVUlxdgYh11gJqUF6BJ05oMJEAaSANpoLmBDw7fHyFPmZ/9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertise_ui_footer_next.png
// module id = QK70
// module chunks = 3